exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".navbar {\n  margin-bottom: 0px;\n}\n\n.expand-all {\n  height: 100%;\n  width: 100%;\n}\n\n:host >>> app-home > div:nth-of-type(1){\n  width: 100%;\n  height: 100%;\n}\n\n:host >>> #title-panel {\n  width: 100%;\n  height: 100%;\n  background-color: transparent;\n}\n\n::ng-deep .background {\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  z-index: -1;\n  padding: 10px;\n  /*background-color: #C49651;*/\n  background-color: #844E1B;\n\n  -webkit-filter: blur(5px);\n  -moz-filter: blur(5px);\n  -o-filter: blur(5px);\n  -ms-filter: blur(5px);\n  filter: blur(5px);\n  opacity: 0.7;\n}\n\n::ng-deep h1, ::ng-deep h2 , ::ng-deep h3 , ::ng-deep h4 {\n  font-family: 'Dancing Script', cursive;\n  font-size: 400%;\n  color: #eeddbb;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/Jose.Soto/Documents/Websites/SecretSanta/src/app/app.component.css
// module id = ../../../../../src/app/app.component.css
// module chunks = main